export const getDefaultState = () => {
  return {
    subletInvoiceStatuses: [],
    subletInvoiceItemCategories: [],
    subletInvoiceSubletCodes: [],
    subletInvoiceHistory: [],
    invoices: {},
    searchSubletInvoices: [],
    reviewSubletInvoices: [],
    invoice: {},
    dbInvoice: {},
    filteredInvoices: [],
    isFreezePdf: false,
    subletInvoicePos: []
  };
};
export default {
  ...getDefaultState()
};
